<template>
    <v-card
        :class="`marketing-story marketing-story--${color} my-3`"
        flat>
        <img
            v-if="story.imgUrl"
            :src="story.imgUrl"
            alt="headshot"
            class="marketing-story__img"/>
        <div class="marketing-story__content">
            <p
                v-if="story.title"
                class="marketing-story__title mb-2">
                {{story.title}}
            </p>
            <p class="marketing-story__text">{{story.text}}</p>
            <a
                v-if="story.link"
                :href="story.link"
                target="_blank"
                class="mr-2 text-decoration-underline marketing-story__link">
                Read More
            </a>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "marketing-story",
    props: {
        color: String,
        story: Object
    },
    computed: {
        maxSize() {
            return "98px";
        },
    }
}
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";
    @import "../../styles/_variables.scss";

    .marketing-story {
        display: flex;
        align-items: center;
        margin: 5px 0;

        border: 1px solid;
        border-radius: 5px;
        padding: 8px;

        p{
            margin-bottom: 0px;
        }

        &__img{
            height: 100px;
            width: 100px;
            aspect-ratio: 1/1;
            object-fit: cover;

            border: 1px solid;
            border-radius: 5px;
        }

        &__content{
            display: flex;
            flex-direction: column;
            width: 100%;

            padding-left: 8px;
        }

        &__title{
            font-family: 'Libre Franklin';
            font-weight: bold;
        }

        &__text{
            font-family: 'Roboto', sans-serif;
            line-height: 16px;
            font-size: 14px;
        }

        &__link{
            align-self: flex-end;
            font-weight: bold;
            font-size: 14px;
        }

        &--all{
            @include marketingStory($all, $allLighten2)
        }
        &--aapi{
            @include marketingStory($aapi, $aapiLighten2);
        }
        &--black {
            @include marketingStory($black, $blackLighten2);
        }
        &--flipped{
            @include marketingStory($flipped, $flippedLighten2)
        }
        &--lgbtq{
            @include marketingStory($lgbtq, $lgbtqLighten2)
        }
        &--new{
            @include marketingStory($new, $newLighten2)
        }
        &--poc{
            @include marketingStory($poc, $pocLighten2)
        }
        &--technology{
            @include marketingStory($technology, $technologyLighten2)
        }
        &--women{
            @include marketingStory($women, $womenLighten2)
        }
        &--gotv{
            @include marketingStory($gotv, $gotvLighten2)
        }
        &--primary{
            @include marketingStory($primary, $primaryLighten2)
        }
        &--latino{
            @include marketingStory($latino, $latinoLighten2)
        }
        &--native_american{
            @include marketingStory($nativeAmerican, $nativeAmericanLighten2)
        }
    }
</style>
